module.exports = __webpack_public_path__ + "static/eastpoint-logo-06200014b70804f62f787cf255d8daec.png";